export default {
  columns: {
    strategy: 'Strategia',
    source: 'Sorgente',
    async: 'Asincrono',
    content: 'Contenuto',
    edit: 'Modifica',
    delete: 'Elimina',
  },
  buttons: {
    add_script: 'Aggiungi script',
  },
};
